import { PROVIDER_LABEL, type SocialProvider } from "../lib/authProviders";

function GoogleMark() {
  // Official multicolour "G" (Google Identity branding guidelines).
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

function AppleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M16.37 12.64c.03 3.07 2.69 4.09 2.72 4.1-.02.07-.42 1.46-1.4 2.89-.85 1.24-1.73 2.47-3.12 2.5-1.36.02-1.8-.81-3.36-.81s-2.05.78-3.34.83c-1.34.05-2.36-1.34-3.22-2.57-1.75-2.53-3.09-7.16-1.29-10.28.89-1.55 2.49-2.53 4.22-2.56 1.32-.02 2.56.89 3.36.89.8 0 2.31-1.1 3.9-.94.66.03 2.53.27 3.72 2.02-.1.06-2.22 1.3-2.19 3.93zM13.8 4.55c.71-.86 1.19-2.05 1.06-3.24-1.02.04-2.26.68-2.99 1.54-.66.76-1.23 1.98-1.08 3.14 1.14.09 2.3-.58 3.01-1.44z"
      />
    </svg>
  );
}

export function ProviderButton({
  provider,
  action,
  busy,
  disabled,
  onClick,
}: {
  provider: SocialProvider;
  action: "Continue" | "Connect";
  busy: boolean;
  disabled?: boolean;
  onClick: () => void;
}) {
  const label = `${action} with ${PROVIDER_LABEL[provider]}`;
  return (
    <button
      type="button"
      className={`btn btn-provider btn-provider-${provider} btn-block`}
      onClick={onClick}
      disabled={busy || disabled}
      aria-busy={busy}
      aria-label={label}
    >
      {provider === "google" ? <GoogleMark /> : <AppleMark />}
      <span>{busy ? "Opening…" : label}</span>
    </button>
  );
}
